"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: theme.spacing(6, 6, 3),
        [theme.breakpoints.up(733)]: {
            padding: theme.spacing(6, 0)
        },
        [theme.breakpoints.up(744)]: {
            padding: theme.spacing(6)
        },
        [theme.breakpoints.up(768)]: {
            maxWidth: 984,
            margin: theme.spacing(0, 'auto')
        },
        [theme.breakpoints.up(1080)]: {
            padding: theme.spacing(12, 0, 10)
        }
    };
});
